
import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      isChecked: true,
    }
  },
  mounted() {
    this.onToggle()
  },
  methods: {
    onToggle() {
      let height = 0

      const contentDom = this.$refs.content as HTMLDivElement

      if (this.$data.isChecked) {
        const innerDom = this.$refs.contentInner as HTMLDivElement
        height = innerDom.getBoundingClientRect().height
      }

      contentDom.style.maxHeight = `${height}px`
    },
  },
})
